<template>
  <div class="hero">
    <div class="hero-slider">
      <transition-group name="fade">
        <img v-for="(image, index) in images" 
             :key="image.src" 
             :src="image.src" 
             :alt="image.alt" 
             class="hero-image"
             v-show="currentIndex === index" />
      </transition-group>
    </div>
    <div class="hero-content">
      <h1 class="hero-title">AI 台球智囊团，让每一杆击球，<br>都充满智慧</h1>
      <p class="hero-subtitle">会说话的台球桌，让每一次击球都成为焦点</p>
      <div class="hero-buttons">
        <button class="btn btn-primary">预约体验</button>
        <button class="btn btn-secondary">了解更多</button>
      </div>
    </div>
    <div class="slider-dots">
      <button v-for="(dot, index) in images" 
              :key="index"
              :class="['dot', { active: currentIndex === index }]"
              @click="setCurrentIndex(index)"
              :aria-label="'切换到图片 ' + (index + 1)">
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Hero',
  data() {
    return {
      currentIndex: 0,
      images: [
        { src: require('../assets/hero/pool-table.jpg'), alt: '智能台球1' },
        { src: require('../assets/hero/pool-table2.jpg'), alt: '智能台球2' },
        { src: require('../assets/hero/pool-table3.jpg'), alt: '智能台球3' }
      ],
      timer: null
    }
  },
  methods: {
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length
    },
    setCurrentIndex(index) {
      this.currentIndex = index
      this.resetTimer()
    },
    resetTimer() {
      clearInterval(this.timer)
      this.timer = setInterval(this.nextImage, 3000)
    }
  },
  mounted() {
    this.timer = setInterval(this.nextImage, 3000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
.hero {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 60px;
  width: 100%;
  height: 80vh;
  overflow: hidden;
  position: relative;
}

.hero-slider {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.hero-image {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slider-dots {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  border: none;
  padding: 0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot.active {
  background-color: white;
  transform: scale(1.2);
}

@media (max-width: 768px) {
  .slider-dots {
    bottom: 15px;
  }
  
  .dot {
    width: 10px;
    height: 10px;
  }
}

.hero-content {
  position: absolute;
  text-align: center;
  color: white;
  max-width: 800px;
  padding: 0 20px;
}

.hero-title {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
  line-height: 1.4;
}

.hero-subtitle {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  opacity: 0.9;
}

.hero-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.btn {
  padding: 0.8rem 2rem;
  font-size: 1.1rem;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background-color: #ff0000;
  color: white;
}

.btn-primary:hover {
  background-color: #e60000;
}

.btn-secondary {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  backdrop-filter: blur(10px);
}

.btn-secondary:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

@media (max-width: 768px) {
  .hero {
    padding-top: 50px;
    height: 90vh;
    min-height: 500px;
  }

  .hero-content {
    padding: 0 20px;
    width: 100%;
  }

  .hero-title {
    font-size: 1.8rem;
    margin-bottom: 1rem;
    line-height: 1.3;
  }

  .hero-subtitle {
    font-size: 1rem;
    margin-bottom: 1.5rem;
    padding: 0 10px;
  }

  .hero-buttons {
    flex-direction: column;
    gap: 0.8rem;
    width: 100%;
    max-width: 280px;
    margin: 0 auto;
  }

  .btn {
    width: 100%;
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
    border-radius: 6px;
  }

  .slider-dots {
    bottom: 25px;
  }

  .dot {
    width: 8px;
    height: 8px;
  }
}

@media (max-width: 480px) {
  .hero {
    height: 80vh;
    min-height: 450px;
  }

  .hero-content {
    padding: 0 15px;
  }

  .hero-title {
    font-size: 1.6rem;
    margin-bottom: 0.8rem;
  }

  .hero-subtitle {
    font-size: 0.9rem;
    margin-bottom: 1.2rem;
  }

  .btn {
    padding: 0.7rem 1.2rem;
    font-size: 0.95rem;
  }

  .slider-dots {
    bottom: 20px;
  }
}
</style>